import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-document-ocr-shell',
  standalone: true,
  imports: [RouterOutlet, RouterLink, RouterLinkActive],
  templateUrl: './document-ocr-shell.component.html',
  styleUrl: './document-ocr-shell.component.scss',
})
export class DocumentOcrShellComponent {
  readonly tabs = [
    { label: 'Capture', path: 'capture' },
    { label: 'Documents', path: 'documents' },
  ];
}
